/*************************** 全局变量配置文件 ***************************/
export default (function(win) {
  const config = {
      dev: {
          baseURL: 'https://mit-gateway-sit.livit.run',
          appId: 'wx8a90e96d37344af0',
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: false,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://sit-ecback.sfli.com.cn',
      },
      devserver: {
          domainURL: 'https://wx-dev.livit-life.com',
          baseURL: 'https://gateway-dev.livit-life.com', //颜
          appId: 'wx8a90e96d37344af0',
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: false,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://sit-ecback.sfli.com.cn',
      },
      dat: {
          domainURL: 'https://mit-prospectus-sit.livit.run',
          baseURL: 'https://mit-gateway-sit.livit.run', //颜
          appId: 'wx283123702342200b',
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: true,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://mit-ecback-sit.livit.run',
          gamgalebaseURL:'https://mit-ecback-sit.livit.run',
          gamgaldomainURL:'https://si-wx.sfli.com.cn' //cdn域名
      },
      k8s:{
          domainURL: 'https://mit-wx-sit.livit.run', //domainURL: 'https://ecwebsit.huaguilife.cn',
          baseURL: 'https://mit-gateway-sit.livit.run', //颜
          appId: 'wx283123702342200b',
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: true,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://mit-ecback-sit.livit.run',
          gamgalebaseURL:'https://mit-ecback-sit.livit.run',
          gamgaldomainURL:'https://si-wx.sfli.com.cn' //cdn域名
      },
      uat: {
          domainURL: 'https://mit-prospectus-uat.livit.run',
          baseURL: 'https://mit-gateway-uat.livit.run', //zhaowei
          appId: 'wxee2016f623aa791b', //蒋军杰的号
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: false,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://mit-ecback-uat.livit.run',
          gamgalebaseURL:'https://mit-ecback-uat.livit.run/',
          gamgaldomainURL:'/' //cdn域名
      },
      stg: {
          domainURL: 'https://mit-prospectus-prep.livit-life.com',
          baseURL: 'https://mit-gateway-prep.livit.run', //zhaowei
          appId: 'wx3fc669e02881b313', //sunliang的号
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: false,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://ecback-prep.sfli.com.cn',
      },
      prd: {
          domainURL: 'https://mit-prospectus.livit-life.com',
          baseURL: 'https://gateway.livit-life.com', //zhaowei
          appId: 'wx06acca65d77785b0', //sunliang的号
          resourceServer: 'https://ecwebsit.huaguilife.cn',
          isVConsole: false,
          isEcback: false,
          oldDomainURL: 'https://wxtest.huaguilife.cn',
          ecbackURL: 'https://ecback.livit-life.com',
      }
  };

  // 可回溯 api接口地址设置
  window.ecConfig = {
      apiUrl: `${config[process.env.VUE_APP_UNIT].ecbackURL}/ecback/h5/pushData`,
      debug: false
  };
  console.log(`欢迎进入小康人寿${process.env.VUE_APP_UNIT}环境`);
  win.config = config[process.env.VUE_APP_UNIT];
  return config[process.env.VUE_APP_UNIT];
})(window);
